/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddShiftRequest as AgentApiContractAddShiftRequest } from '../../models/AgentApi/Contract/add-shift-request';
import { AddShiftResponse as AgentApiContractAddShiftResponse } from '../../models/AgentApi/Contract/add-shift-response';

export interface ApiAgentAddShiftPost$Params {

/**
 * interface language/null
 */
  lang?: string;
      body?: AgentApiContractAddShiftRequest
}

export function apiAgentAddShiftPost(http: HttpClient, rootUrl: string, params?: ApiAgentAddShiftPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAddShiftResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentAddShiftPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractAddShiftResponse>;
    })
  );
}

apiAgentAddShiftPost.PATH = '/api/Agent/AddShift';
